import type { RadioOrientation } from '@record-fill';

export type {
  FormStructure,
  ElementType,
  FormElement,
  FontWeight,
  TextDecoration,
  ElementProperties,
  Spacing,
  HeaderProperties,
  FixedTextProperties,
  TextInputProperties,
  NumberInputProperties,
  NumberType,
  ParagraphProperties,
  DateFieldType,
  DateInputProperties,
  UrlInputProperties,
  RegisterNumberInputProperties,
  IndexerType,
  IndexerTitleProperties,
  FillTitleType,
  FillTitleProperties,
  EmailInputProperties,
  RadioOrientation,
  RadioGroupProperties,
  ImageProperties,
  CheckboxOption,
  CheckboxOrientation,
  CheckboxProperties,
  AlternativeItem,
  DropdownListType,
  DropdownProperties,
  TableElement,
  TableProperties,
  TableCell,
  MergedCell,
  BorderSide,
  CellContentAlignment,
  CellProperties,
} from '@record-fill';

export const RADIO_GROUP_DEFAULTS = {
  ORIENTATION: 'vertical' as RadioOrientation,
  LABEL_POSITION: 'top' as const,
  OPTIONS: ['Opção 1', 'Opção 2'],
} as const;

export interface ZoomProps {
  minZoom?: number;
  maxZoom?: number;
  zoomStep?: number;
}
